import { useState, type FormEvent } from "react";
import { signInWithEmail, humanizeAuthError } from "../auth";

interface Props {
  onGoSignup?: () => void;
}

export function LoginScreen({ onGoSignup }: Props) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      await signInWithEmail(email, password);
    } catch (err) {
      const code = (err as { code?: string }).code;
      setError(humanizeAuthError(code) ?? (err as Error).message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="login-screen">
      <div className="login-card">
        <h1>Orchestration Coach</h1>
        <p className="subtitle">Sign in with your invited account.</p>
        <form onSubmit={handleSubmit}>
          <label htmlFor="login-email">Email</label>
          <input
            id="login-email"
            type="email"
            placeholder="Email"
            autoComplete="username"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <label htmlFor="login-password">Password</label>
          <input
            id="login-password"
            type="password"
            placeholder="Password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <button type="submit" disabled={submitting}>Sign in</button>
        </form>
        {error && <div className="banner error">{error}</div>}
        <p className="footnote">
          No account yet?{" "}
          {onGoSignup ? (
            <button className="btn btn--text" onClick={onGoSignup}>
              Create one
            </button>
          ) : (
            "Ask your administrator to invite you."
          )}
        </p>
      </div>
    </div>
  );
}
